'use client';

import { useMutation } from '@tanstack/react-query';

import { ANALYTICS_QUERIES } from '../../infrastructure/analytics';

export const useAnalyticsService = () => {
  const useTrackEvent = () => {
    return useMutation(ANALYTICS_QUERIES.trackEvent());
  };

  return {
    useTrackEvent,
  };
};
